/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseFileParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('file')],
    ['id', codecString],
    ['name', codecString],
    ['size', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
    ['hash', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class BaseFile extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseFileParser.decode(input).map(res => new BaseFile(res));
    }
    static unsafeDecode(input) {
        return BaseFile.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseFileParser.encode(data);
    }
    static schema() {
        return BaseFileParser.schema();
    }
}
